import {LoginUser} from "@/types/Component";
import moment from "moment";

export function changeNumberFormat(value: number): string | null {
    return Math.round(value).toLocaleString().replace(/^-/, '▲')
}

export function applyNumberFixed(value: number): string | null {
    return Number(value).toFixed(3).toLocaleString()
}

export function fixNumberLength(value: string): string | null {
    return value.length > 7 ? value.substring(0, 7) + '…' : value
}

export function changeDateFormat(value: string): string {
    return moment(value).format('YYYY年M月D日')
}

export function isAdmin(loginUser: LoginUser): boolean {
    return loginUser.role.find((role: string) => {
        return role === 'ADMIN'
    }) !== undefined;
}
